import React, { useEffect, useState } from "react";

export default function ContentPersonalNoteForm({ context, initialNote, onCancel, onSubmit, submitting }) {
    const [noteTitle, setNoteTitle] = useState("");
    const [noteText, setNoteText] = useState("");

    useEffect(() => {
        setNoteTitle(initialNote?.noteTitle || "");
        setNoteText(initialNote?.noteText || "");
    }, [initialNote]);

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit?.({
            noteTitle,
            noteText,
            noteContextType: context?.noteContextType,
            videoTimestampSeconds: context?.videoTimestampSeconds,
            pdfPage: context?.pdfPage,
            scormNodeId: context?.scormNodeId,
            scormNodeTitle: context?.scormNodeTitle,
            scrollPosition: context?.scrollPosition,
        });
        if (!initialNote) {
            setNoteTitle("");
            setNoteText("");
        }
    };

    return (
        <form className="pn-form" onSubmit={handleSubmit}>
            <input
                className="pn-input"
                value={noteTitle}
                onChange={(event) => setNoteTitle(event.target.value)}
                placeholder="Titre optionnel"
                maxLength={255}
            />
            <textarea
                className="pn-textarea"
                value={noteText}
                onChange={(event) => setNoteText(event.target.value)}
                placeholder="Ecrire une note personnelle"
                required
            />
            <div className="pn-actions">
                <button type="submit" className="pn-btn pn-btn--primary" disabled={submitting}>
                    {initialNote ? "Enregistrer" : "Ajouter la note"}
                </button>
                {initialNote ? (
                    <button type="button" className="pn-btn" onClick={onCancel} disabled={submitting}>
                        Annuler
                    </button>
                ) : null}
            </div>
        </form>
    );
}
